import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class AutoProviderModel extends BaseModel {
  static urlPath = "auto/providers";

  @attr("number") pk;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("string") name;
  @attr("string") phone;
  @attr("string") address;
  @attr("string") primaryEmail;
  @attr("string") shopEmail;
  @attr("string") referralsEmail;
}
